import { VisibilityOff, Visibility } from '@mui/icons-material';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { memo, useState } from 'react';

import { TextFieldProps } from '@mui/material/TextField';

const PasswordField = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  ...props
}: TextFieldProps) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: { preventDefault: () => void }) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event: { preventDefault: () => void }) => {
    event.preventDefault();
  };
  return (
    <TextField
      {...props}
      name={name}
      label={label}
      value={value}
      type={showPassword ? 'text' : 'password'}
      onBlur={onBlur}
      onChange={onChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              onMouseUp={handleMouseUpPassword}
              edge="end"
            >
              {!showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default memo(PasswordField);
